export function isServerAdmin(user) {
  return user?.roles?.includes("admin")
}
